<app-navbar-style-two></app-navbar-style-two>

<div class="contact-page">
    <div class="contact-1">
        <!-- BANNER -->
        <!-- BANNER -->
        <div class="banner">
            <img src="assets/img/contact/uae.png" alt="UAE" />
            <h1>UAE</h1>
        </div>

        <!-- FORM CARD -->
        <div class="form-card container">
            <h2>Contact Us</h2>
            <p>
                UNIKAI is committed to delivering reliable support and clear communication. Our customer relations team
                is available to assist with inquiries, concerns, and feedback. For urgent matters, please reach out
                through our customer care hotline, or submit your request via the online form or email for non-urgent
                communication. Every message is reviewed with care, as your insights help us strengthen our service
                standards and customer experience.
            </p>

            <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">

                <!-- Row 1: Name + Mobile (careers-style grid-2) -->
                <div class="details-box">
                    <div class="grid-3">
                        <div class="form-group">
                            <label>Full Name <span class="required">*</span></label>
                            <input type="text" formControlName="name">
                        </div>

                        <div class="form-group">
                            <label>Mobile Number <span class="required">*</span></label>
                            <ngx-intl-tel-input
                                cssClass="career-phone-input"
                                [preferredCountries]="preferredPhoneCountries"
                                [selectedCountryISO]="defaultPhoneCountry"
                                [searchCountryFlag]="true"
                                [enablePlaceholder]="true"
                                [maxLength]="PHONE_NATIONAL_MAX"
                                [phoneValidation]="true"
                                [inputId]="'contact-uae-mobile'"
                                formControlName="mobile">
                            </ngx-intl-tel-input>
                            <small class="text-danger"
                                   *ngIf="contactForm.get('mobile')?.invalid && contactForm.get('mobile')?.touched">
                                Valid phone required ({{ PHONE_NATIONAL_MIN }}-{{ PHONE_NATIONAL_MAX }} digits)
                            </small>
                        </div>
                        <div class="form-group">
                            <label>Email Address <span class="required">*</span></label>
                            <input type="email" formControlName="email">
                        </div>
                    </div>
                </div>

                <!-- Row 2: Email + Emirates -->
                <div class="details-box">
                    <div class="grid-3">
                        <div class="form-group">
                            <label>Emirates <span class="required">*</span></label>
                            <select class="no-nice-select" formControlName="city">
                                <option value="" disabled selected>Select Emirates</option>
                                <option *ngFor="let c of cities" [value]="c">{{ c }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Subject <span class="required">*</span></label>
                            <select class="no-nice-select" formControlName="subject">
                                <option value="" disabled selected>Select Subject</option>
                                <option *ngFor="let e of enquiryTypes" [value]="e.label">{{ e.label }}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Enquiry Type <span class="required">*</span></label>
                            <select class="no-nice-select" formControlName="enquiryType">
                                <option value="" disabled selected>Select Enquiry Type</option>
                                <option *ngFor="let e of enquiryTypes" [value]="e.label">{{ e.label }}</option>
                            </select>
                        </div>
                        
                    </div>
                </div>

                <!-- Row 3: Subject + Enquiry Type -->
                <div class="details-box">
                    <div class="grid-2">
                        
                    </div>
                </div>

                <!-- Row 4: Message full width -->
                <div class="details-box">
                    <div class="grid-1">
                        <div class="form-group">
                            <label>Message</label>
                            <textarea rows="4" formControlName="message"></textarea>
                        </div>
                    </div>
                </div>

                <button class="submit-btn" type="submit" [disabled]="submitting">
                    {{ submitting ? 'SUBMITTING...' : 'SUBMIT' }}
                </button>

            </form>

            <hr />

            <!-- QUICK CONNECT -->
            <div class="quick-connect">
                <h3 class="quick-connect-title">Quick Connect</h3>

                <div class="quick-connect-content">
                    <div class="icon-block">
                        <i class="bx bx-map"></i>
                        <p>{{ quickAddress }}</p>
                    </div>
                    <div class="icon-block">
                        <i class="bx bx-phone"></i>
                        <p>{{ quickPhone }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="contact-2">
        <!-- BRANCHES -->
        <div class="branches container">
            <div class="branch-card" *ngFor="let b of branches">
                <div class="icon-block">
                    <i class="bx bx-map"></i>
                </div>
                <div class="address-block">
                    <h4>{{ b.title }}</h4>
                    <p>{{ b.address }}</p>
                    <a [href]="'tel:' + b.phone">{{ b.phone }}</a>
                    <small>{{ b.timing }}</small>
                </div>
            </div>
        </div>
    </div>
    <!-- SOCIAL LINKS -->
    <div class="social text-center">
        <h5>Follow us</h5>
        <div class="icons">
            <a [href]="socialLinks.facebook"><i class="bx bxl-facebook"></i></a>
            <a [href]="socialLinks.tiktok"><i class="bx bxl-tiktok"></i></a>
            <a [href]="socialLinks.instagram"><i class="bx bxl-instagram"></i></a>
            <a [href]="socialLinks.linkedin"><i class="bx bxl-linkedin"></i></a>
        </div>
    </div>
</div>

<app-footer-style-one></app-footer-style-one>